// Real-device reel startup metric (activation → first rendered frame), batched to
// the backend as anonymous aggregates only. Fire-and-forget: never blocks playback.
// Lot 555 : chaque mesure porte ses dimensions de diagnostic — réseau (wifi / 4g / 3g / 2g / cell / unk),
// préchargé ou non à l'arrivée, nombre de vues du reel (1re lecture = CDN froid), lecteur utilisé.
import { api } from "@/lib/api";
import { Capacitor } from "@capacitor/core";
import { connectionType } from "@/lib/netStatus";

let queue = [];
let timer = null;
const PLAT = Capacitor.isNativePlatform() ? Capacitor.getPlatform() : "web";

export const netClass = () => {
  const ct = connectionType();
  if (ct === "wifi") return "wifi";
  const eff = typeof navigator !== "undefined" ? navigator.connection?.effectiveType : "";
  if (eff === "4g") return "4g";
  if (eff === "3g") return "3g";
  if (eff === "2g" || eff === "slow-2g") return "2g";
  return ct === "cellular" ? "cell" : "unk";
};

const flush = () => {
  clearTimeout(timer);
  timer = null;
  if (!queue.length) return;
  const samples = queue.splice(0, 20);
  api.post("/metrics/reels-start", { samples }).catch(() => {});
};

export const recordReelStart = (ms, kind, extra = {}) => {
  if (!(ms >= 0) || ms > 60000) return;
  const s = { ms: Math.round(ms), kind: kind === "hls" ? "hls" : "mp4", plat: PLAT, net: netClass() };
  if (extra.pre === 0 || extra.pre === 1) s.pre = extra.pre;
  if (Number.isFinite(extra.views)) s.views = Math.max(0, Math.round(extra.views));
  if (extra.pl) s.pl = extra.pl;
  queue.push(s);
  if (queue.length >= 5) flush();
  else if (!timer) timer = setTimeout(flush, 15000);
};

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
